import axios from "axios";



import { getToken, removeToken } from "../utils/auth";

const API = axios.create({
  baseURL: "https://www.aceswafund.org",
});


// ✅ Attach token automatically
API.interceptors.request.use((config) => {
  const token = getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});


// ✅ Handle expired token globally
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log("⏰ Token expired → forcing logout");

      removeToken();
      localStorage.removeItem("user");

      window.location.href = "/login"; // hard redirect (safe)
    }

    return Promise.reject(error);
  }
);

export default API;